import React from 'react';
import { Typography } from '@mui/material';

import { FilledButton } from 'shared-components/Buttons';
import {
  Container,
  Content,
  ADPKDArea,
} from 'components/Questionnaire/common/styles';
import Logo from 'images/adpkd-registry-logo.svg';

const End = ({ onEnd, data }) => (
  <Container>
    <ADPKDArea>
      <img
        src={Logo} alt='pkd logo'
      />
    </ADPKDArea>
    <Content>
      <Typography
        variant='h1' mb={4}>
        {data?.title ?? 'Thank you'}
      </Typography>
      <Typography
        variant='h6'
        mb={4}
        dangerouslySetInnerHTML={{ __html: data?.description }}
      />

      <FilledButton
        fullWidth
        background='#00778B'
        height='44px'
        width='200px'
        onClick={onEnd}>
        Go to homepage
      </FilledButton>
    </Content>
  </Container>
);

export default End;
